import React from 'react';
import {config} from "../../../config";
import Helmet from "react-helmet";

import "./ParentalControl.scss";

import icon1p2 from "./images/icon1p2.png";
import imgDefault from "./images/img.png";

import imgp1 from "./images/p1.png";
import imgp2 from "./images/p2.png";
import imgp3 from "./images/p3.png";
import imgp4 from "./images/p4.png";
import imgp5 from "./images/p5.png";
import imgp6 from "./images/p6.png";
import imgp7 from "./images/p7-10.png";
import imgp8 from "./images/p8.png";
import imgp9 from "./images/p9.png";
import imgp10 from "./images/p10.png";

const ParentalControl = (props) => {
    window.scrollTo(0, 0);
    return (

        <div id="controle-parental">

            <Helmet>
                <title>{config.preTitle}Contrôle parental{config.postTitle}</title>
            </Helmet>
            <section className="page_topsection1">
                <div className="page_container">
                    <div className="icontitle"><img src={icon1p2} alt="Contôle parental" width="132" /></div>
                    <h1 className="title_topsection1">
                        Contrôle parental<br />
                        <span className="subtitle_topsection1">Voissa ne veut pas être assimilé à un site “porno”.</span>
                    </h1>

                </div>
            </section>

            <section className="page_contentsection2">
                <div className="page_container2">
                    <div className="imgbloc"><img src={imgDefault} width="100%" alt={"apple"}/></div>
                    <div className="txtbloc">
                        <span>Voissa est un espace de liberté qui autorise la nudité et la diffusion de contenus à caractère sexuel par ceux qui le font dans le cadre de leur épanouissement sexuel.</span>
                        <br /><br />
                        Voissa encourage des pratiques saines du sexe, mettant en valeur le respect, la sensualité, le
                        consentement, l’amour… tout le contraire des vidéos hard produites et distribuées sur les tube
                        sites et sites “porno” qui exploitent l’image de la femme.
                        <br /><br />
                        Sur Voissa ce sont de vraies personnes qui se dévoilent, en solo ou en couple, et quand bien
                        même Voissa ne cherche pas à attirer les mineurs, l’implication des parents est nécessaire
                        pour préserver nos enfants de ces contenus.
                        <br /><br />
                        <span>Nous souhaitons aider les parents à jouer ce rôle de protection en fournissant des informations utiles.</span>
                        <br /><br />
                        Cela passe par le paramétrage de votre box, des fonctions natives de contrôle
                        parental (iOS, Android) des appareils utilisés par vos enfants, voire en installant
                        des logiciels puissants sur le parc numérique de votre foyer : Smartphones,
                        Tablettes & Ordinateurs.
                    </div>
                </div>

            </section>

            <section className="page_contentsection1 bg">
                <div className="page_container">
                    <div className="titrebloc">
                        Nous vous recommandons de lire ce guide qui traite très bien <br className="hidemob" />le sujet du <a href="https://www.echosdunet.net/dossiers/controle-parental" target="_blank" rel="nofollow noopener noreferrer">contrôle parental</a>.
                    </div>
                    <div className="list_bloc">
                        <div className="title">Des solutions gratuites et à la portée de tous :</div>
                        <div className="content_bloc">
                            <div className="logo"><img src={imgp1} alt="Apple" /></div>
                            <div className="titre">
                                Contrôle parental Iphone/Ipad (avec le temps d’écran)
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/iphone" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>

                        </div>

                        <div className="content_bloc imp">
                            <div className="logo"><img src={imgp2} alt="Apple" /></div>
                            <div className="titre">
                                Contrôle parental Smartphone et Tablette Android
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/android" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span></div>
                        </div>
                        <div className="content_bloc">
                            <div className="logo"><img src={imgp3} alt="Apple" /></div>
                            <div className="titre">
                                Contrôle parental SFR
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/sfr" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="content_bloc imp">
                            <div className="logo"><img src={imgp4} alt="Apple" /></div>
                            <div className="titre">
                                Contrôle parental Bouygues
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/bouygues" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="content_bloc">
                            <div className="logo"><img src={imgp5} alt="Apple" /></div>
                            <div className="titre">
                                Contrôle parental Free
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/free" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="content_bloc imp">
                            <div className="logo"><img src={imgp6} alt="Apple" /></div>
                            <div className="titre">
                                Contrôle parental Orange
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/orange" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="content_bloc">
                            <div className="logo"><img src={imgp7} alt="Apple" /></div>
                            <div className="titre">Comment utiliser le contrôle parental sur tablette ?
                                <span className="link"><a href="https://www.echosdunet.net/dossiers/controle-parental/tablette" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <section className="page_contentsection1">
                <div className="page_container">
                    <div className="titrebloc">
                        <span>Pour aller plus loin : </span><br />
                        Vous pouvez également étudier l’intérêt d’installer des logiciels spécifiques
                        de filtrage de contenus, qui sont facilement accessibles sur Internet, tels que :
                    </div>
                    <div className="list_bloc paddtop">
                        <div className="content_bloc">
                            <div className="logo"><img src={imgp7} alt="Apple" /></div>
                            <div className="titre">
                                CovenantEyes (payant)
                                <span className="link"><a href="https://www.covenanteyes.com/" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>

                        <div className="content_bloc imp">
                            <div className="logo"><img src={imgp8} alt="Apple" /></div>
                            <div className="titre">
                                x3watch (payant)
                                <span className="link"><a href="https://x3watch.com/" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="content_bloc">
                            <div className="logo"><img src={imgp9} alt="Apple" /></div>
                            <div className="titre">
                                Qustodio (payant et gratuit)
                                <span className="link"><a href="https://www.qustodio.com/" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="content_bloc imp">
                            <div className="logo"><img src={imgp10} alt="Apple" /></div>
                            <div className="titre">
                                Netnanny (payant)
                                <span className="link"><a href="https://www.netnanny.com/" target="_blank" rel="nofollow noopener noreferrer">Voir le tutoriel</a></span>
                            </div>
                        </div>
                        <div className="seperate"></div>
                        <div className="subtitrebloc">
                            Il est également possible de filtrer sans logiciel à installer <br className="hidemob" />
                            en consultant <a href="https://lecrabeinfo.net/bloquer-les-sites-x-porno-et-contenu-choquant-sur-pc.html" target="_blank" rel="nofollow noopener noreferrer">ce tutoriel</a>.
                        </div>

                    </div>
                </div>
            </section>


            <section className="page_contentsection1 bgwhite">
                <div className="page_container">
                    <div className="textloi"><span>Rappel de la loi :</span><br />Article 227-22 du Code Pénal : Le fait
                        de favoriser ou de tenter de favoriser la corruption d'un mineur est puni de cinq ans
                        d'emprisonnement et de 75 000 euros d'amende. Ces peines sont portées à sept ans
                        d'emprisonnement et 100 000 euros d'amende lorsque le mineur a été mis en contact avec l'auteur
                        des faits grâce à l'utilisation, pour la diffusion de messages à destination d'un public non
                        déterminé, d'un réseau de communications électroniques ou que les faits sont commis dans les
                        établissements d'enseignement ou d'éducation ou dans les locaux de l'administration, ainsi que,
                        lors des entrées ou sorties des élèves ou du public ou dans un temps très voisin de celles-ci,
                        aux abords de ces établissements ou locaux. Les mêmes peines sont notamment applicables au fait,
                        commis par un majeur, d'organiser des réunions comportant des exhibitions ou des relations
                        sexuelles auxquelles un mineur assiste ou participe ou d'assister en connaissance de cause à de
                        telles réunions. Les peines sont portées à dix ans d'emprisonnement et 1 000 000 euros d'amende
                        lorsque les faits ont été commis en bande organisée ou à l'encontre d'un mineur de quinze ans.
                    </div>

                </div>
            </section>


        </div>

    )
};

export default ParentalControl;